export type SanityPageDocument = 'blogPost' | 'page' | 'research'

export const typeNameBasePathConfig: Record<SanityPageDocument, string> = {
  blogPost: '/blog',
  page: '',
  research: '/research-and-education/research-details',
}

function isSanityPageDocument(value: string | null | undefined): value is SanityPageDocument {
  return !!value && value in typeNameBasePathConfig
}

export function basePathForTypeName(typeName: string | null | undefined): string {
  return isSanityPageDocument(typeName) ? typeNameBasePathConfig[typeName] : ''
}
